<template>
    <div class="message-container">
        <div class="message-list">
            <div class="message-item" v-for="(item, index) in messageList" :key="index">
                <div class="message-content">
                    <h3 class="title">{{ item.eventTypeTitle }}</h3>
                    <p class="desc">{{ item.content }}</p>
                    <div class="btn" v-if="item.customParam != ''" @click="handMessageDetail(item)">{{ $t('agencyList.lang8') }}></div>
                    <span class="time">{{ item.createdAt }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getBrowser } from "@/utils/browser";
export default {
    name: 'message',
    data() {
        return {
            messageList: [],
            userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
        }
    },
    mounted() {
        this.getMessageList()
        this.updateRead()
    },
    methods: {
        getMessageList() {
            const query = {
                userId: this.userInfo.user_id,
                source: 'int_futuresapp',
                noticeType: [this.$route.query.noticeType],
                pageSize: 500,
                currentPage: 1,
            }
            this.$apis.getStationMessageListApiV2(query).then(res => {
                this.messageList = res.infos || []
            })
        },
        handMessageDetail(item) {
            if (!item.customParam) return
            const customParam = item.customParam.startsWith('{') ? JSON.parse(item.customParam) : {}
            if ( getBrowser().isApp ) {
                this.$JsBridge.callHandler('jumpPage', {
                    type: 1,
                    url: customParam.url
                })
            } else {
                customParam?.url && (window.location.href = customParam.url)
            }
        },
        updateRead() {
            this.$apis.getStationMessageReadSetApiV2({
                userId: this.userInfo.user_id,
                source: 'int_futuresapp',
                noticeType: [this.$route.query.noticeType],
            })
        }
    }
}
</script>

<style lang="less" scoped>
.message-container {
    background: #f9fafc, #ffffff;
    min-height: 100vh;
    padding: 0px 32px;

    .message-list {
        .message-item {
            background: #fff;
            border-radius: 8px;
            border-bottom: 1px solid #f3f3f3;
            padding: 32px 0px;
            .message-content {
                .title {
                    font-size: 32px;
                    line-height: 40px;
                    font-weight: 500;
                    color: #17161C;
                    margin: 0 0 20px;
                }

                .desc {
                    font-size: 28px;
                    color: #17161C;
                    margin: 0 0 18px;
                }

                .time {
                    font-size: 28px;
                    line-height: 28px;
                    color: #747377;
                    display: block;
                }
                .btn {
                    font-size: 28px;
                    line-height: 28px;
                    color: #328CF4;
                    margin-bottom: 12px;
                    display: block;
                }
            }
        }
    }
}
.black-theme {
    .message-container {
        .message-list {
            .message-item {
                background: #1B1C24;
                border-bottom: 1px solid #323442;
                .message-content {
                    .title {
                        color: white;
                    }
                    .desc {
                        color: #9D9D9F;
                    }
                    .time {
                        color: white;
                    }
                    .btn {
                        color: #377CFB;
                    }
                }
            }
        }
    }
}
</style>